import React from 'react';
import { ThemeProvider } from '@mui/material';

import { theme } from 'Modules/ui3';
import { ChainedRender } from 'Modules/core/react';


export const ThemeProviderRender: ChainedRender = ({ Next }) => (
    <ThemeProvider theme={theme}>
        <Next />
    </ThemeProvider>
);
